import "./AssignOwnerFilterControl.css";

import { Badge, Box, ButtonSelect, Icon } from "@saviynt/design-system";
import { useIntl } from "react-intl";

import { useAssignOwnerFilter } from "./AssignOwnerFilterContext";
import { isEmpty } from "../../../../../util";
import SearchBar from "../SearchBar/SearchBar";

interface AssignOwnerFilterControlProps {
  isFilterOpen: boolean;
  handleFilterClick: () => void;
  searchValue: string;
  onSearchChange: React.Dispatch<React.SetStateAction<string>>;
}

export default function AssignOwnerFilterControl({
  isFilterOpen,
  handleFilterClick,
  searchValue,
  onSearchChange,
}: AssignOwnerFilterControlProps) {
  const intl = useIntl();
  const { selectedFilters } = useAssignOwnerFilter();
  const hasSelectedFilters = !isEmpty(selectedFilters);

  const buttonSelectShowBadge =
    !isFilterOpen && hasSelectedFilters ? (
      <Badge kind="dot" color="primary" dataTestId="filter-badge" />
    ) : null;

  return (
    <Box className="flex items-center gap-4">
      <Box className="AssignOwner-toolbar-search">
        <SearchBar
          value={searchValue}
          setValue={onSearchChange}
          dataTestId="NHI-AssignOwner-search-bar"
        />
      </Box>
      <Box className="AssignOwner-toolbar-filter">
        <ButtonSelect
          label={intl.formatMessage({
            defaultMessage: "Filter",
            id: "vxq3Bj",
            description: "Label for filter button",
          })}
          isOpen={isFilterOpen}
          onClick={handleFilterClick}
          size="medium"
          prefixIcon={
            <Icon kind="Filter" color="--color-foreground-neutral-subtle" />
          }
          dataTestId="NHI-Inventory-Filter"
          BadgeComp={buttonSelectShowBadge}
        />
      </Box>
    </Box>
  );
}
